var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    size: "small",
                    inline: "",
                    "label-position": "right",
                  },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "时间选择：" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "selWidth",
                        attrs: {
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          size: "small",
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          placement: "bottom-end",
                        },
                        on: { change: _vm.onchangeTime },
                        model: {
                          value: _vm.timeVal,
                          callback: function ($$v) {
                            _vm.timeVal = $$v
                          },
                          expression: "timeVal",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "渠道：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请选择渠道",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.tableFrom.channelId,
                            callback: function ($$v) {
                              _vm.$set(_vm.tableFrom, "channelId", $$v)
                            },
                            expression: "tableFrom.channelId",
                          },
                        },
                        _vm._l(_vm.channelOptions, function (label, value) {
                          return _c("el-option", {
                            key: value,
                            attrs: { label: label, value: parseInt(value) },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "操作步骤：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请选择操作步骤",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.tableFrom.handleType,
                            callback: function ($$v) {
                              _vm.$set(_vm.tableFrom, "handleType", $$v)
                            },
                            expression: "tableFrom.handleType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "发短信", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "下单", value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号码：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入手机号码",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.tableFrom.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableFrom, "phone", $$v)
                          },
                          expression: "tableFrom.phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "平台订单号：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入平台订单号",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.tableFrom.platOrderNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableFrom, "platOrderNo", $$v)
                          },
                          expression: "tableFrom.platOrderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "产品编码：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入产品编码",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.tableFrom.productCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableFrom, "productCode", $$v)
                          },
                          expression: "tableFrom.productCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.handleSearchList },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.handleReset },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "div",
            { staticClass: "mt5" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.exports } },
                [_vm._v("导出Excel")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "mt20",
              attrs: {
                data: _vm.tableData.data,
                size: "small",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "logId",
                  label: "日志ID",
                  "min-width": "100",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "channelId",
                  label: "渠道",
                  "min-width": "120",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "手机号码", "min-width": "130" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "platOrderNo",
                  label: "平台订单号",
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "productCode",
                  label: "产品编码",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "productName",
                  label: "产品名称",
                  "min-width": "200",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "handleType",
                  label: "操作步骤",
                  "min-width": "120",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "appName",
                  label: "应用名称",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "ip", label: "IP地址", "min-width": "130" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "100",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.showDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "请求日志详情",
            visible: _vm.detailVisible,
            width: "80%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _vm.detailData
            ? _c(
                "div",
                { staticClass: "detail-content" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("日志ID："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.logId)),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("渠道："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.channelId)),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("手机号码："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.phone)),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("平台订单号："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.platOrderNo)),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("产品编码："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.productCode)),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("产品名称："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.productName)),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("操作步骤："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.handleType)),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("应用名称："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.appName)),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("应用包名："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.appPackage)),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("IP地址："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.ip)),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("一级触点："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.firstContact)),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("二级触点："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.secContact)),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("短信验证码："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.smsCode)),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("订单号："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.orderNo)),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("页面URL："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.pageUrl)),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("User Agent："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.ua)),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("入参："),
                          ]),
                          _c("div", { staticClass: "value code-block" }, [
                            _vm._v(_vm._s(_vm.detailData.params)),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("结果："),
                          ]),
                          _c("div", { staticClass: "value code-block" }, [
                            _vm._v(_vm._s(_vm.detailData.result)),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("创建时间："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.createTime)),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("更新时间："),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.detailData.updateTime)),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.detailVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }